import { Image } from '@educator/components/Image'
import { SubjectCarousel } from '@mc/educator-design-system'
import { useTranslation } from '@mc/i18n'
import type { SubjectOutcome } from '../../../../types/subjects'
import { SectionContainer } from '../../SectionContainer'
import styles from './SubjectOutcomesSection.module.scss'

const OutcomeCard = ({ outcome }: { outcome: SubjectOutcome }) => (
  <article className='relative w-[280px] h-[384px] overflow-hidden bg-neutral-800'>
    <Image
      src={outcome.imageUrl}
      alt=''
      fill
      className='object-cover'
      aria-hidden='true'
    />
    <div className={styles.cardGradient} aria-hidden='true' />
    <div className='absolute inset-0 flex flex-col justify-end p-4'>
      <h3 className='m-0 text-xl font-normal leading-tight tracking-[-0.01em] text-white'>
        {outcome.description}
      </h3>
    </div>
  </article>
)

interface SubjectOutcomesSectionProps {
  sectionTitle: string
  outcomes: SubjectOutcome[]
}

export const SubjectOutcomesSection = ({
  sectionTitle,
  outcomes,
}: SubjectOutcomesSectionProps) => {
  const { t } = useTranslation('@mc/educator')

  if (outcomes.length === 0) return null

  return (
    <section
      data-section='subject-outcomes'
      aria-label={sectionTitle}
      className='w-full overflow-hidden bg-black py-6 md:py-10'
    >
      <div className='md:hidden'>
        <SectionContainer clipX>
          <SubjectCarousel
            title={sectionTitle}
            gap={24}
            ariaLabel={sectionTitle}
            prevLabel={t('subjectLandingPage.subjectOutcomes.previousOutcome')}
            nextLabel={t('subjectLandingPage.subjectOutcomes.nextOutcome')}
          >
            {outcomes.map((outcome) => (
              <OutcomeCard key={outcome.id} outcome={outcome} />
            ))}
          </SubjectCarousel>
        </SectionContainer>
      </div>

      <div className='hidden md:block'>
        <SectionContainer clipX maxWidth={1152}>
          <SubjectCarousel
            title={sectionTitle}
            gap={24}
            scrollClassName='min-[1024px]:pl-[calc((100vw_-_982px)_/_2)] min-[1024px]:[scroll-padding-left:calc((100vw_-_982px)_/_2)] min-[1153px]:pl-24 min-[1153px]:[scroll-padding-left:96px]'
            ariaLabel={sectionTitle}
            prevLabel={t('subjectLandingPage.subjectOutcomes.previousOutcome')}
            nextLabel={t('subjectLandingPage.subjectOutcomes.nextOutcome')}
          >
            {outcomes.map((outcome) => (
              <OutcomeCard key={outcome.id} outcome={outcome} />
            ))}
          </SubjectCarousel>
        </SectionContainer>
      </div>
    </section>
  )
}
